module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('link', {
    attrs: {
      "rel": "stylesheet",
      "href": "https://cdn.jsdelivr.net/npm/bootstrap@4.6.2/dist/css/bootstrap.min.css",
      "integrity": "sha384-xOolHFLEh07PJGoPkLv1IbcEPTNtaed2xpHsD9ESMhqIYd0nLMwNLD69Npy4HI+N",
      "crossorigin": "anonymous"
    }
  }), _vm._v(" "), _c('meta', {
    attrs: {
      "name": "viewport",
      "content": "width=device-width, initial-scale=1, shrink-to-fit=no"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: " col-md-6 col-12 p-0"
  }, [_c('div', {
    staticClass: "col-12 mx-0 px-3 py-2",
    staticStyle: {
      "background-image": "linear-gradient(rgb(0, 145, 165), rgb(1, 136, 154), rgb(2, 126, 144), rgb(3, 117, 133), rgb(3, 108, 123))",
      "color": "#ffffff"
    }
  }, [_c('h3', [_c('strong', [_vm._v(_vm._s(_vm.msglist[_vm.$route.params.language][5]))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 row mx-0 px-0 py-2 mb-1",
    staticStyle: {
      "background": "rgb(242, 242, 242)"
    }
  }, [_c('div', {
    staticClass: "col-12 px-0 row mx-0"
  }, [_c('div', {
    staticClass: "col border-left align-self-center"
  }, [_c('div', {
    staticClass: "row px-0 mx-0"
  }, [_vm._v(_vm._s(_vm.msglist[_vm.$route.params.language][6]) + " \r\n                  "), _c('div', {
    staticClass: "col px-2 mx-0 mb-2 align-self-center"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.email),
      expression: "user.email"
    }],
    staticClass: "form-control",
    staticStyle: {
      "height": "30px",
      "font-size": "1.2rem",
      "font-weight": "bold"
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.user.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "email", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col px-0 mx-0 mb-2"
  }, [_vm._v(_vm._s(_vm.msglist[_vm.$route.params.language][7]))]), _vm._v(" "), _c('div', {
    staticClass: "col-12 text-center"
  }, [_c('button', {
    staticClass: "mb-2 btn btn-primary",
    staticStyle: {
      "min-width": "100px"
    },
    on: {
      "click": function($event) {
        _vm.getbackaccount()
      }
    }
  }, [_vm._v(_vm._s(_vm.msglist[_vm.$route.params.language][8]))]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'entry',
        params: {
          language: _vm.$route.params.language
        }
      }
    }
  }, [_c('button', {
    staticClass: "mb-2 btn btn-primary",
    staticStyle: {
      "min-width": "40px"
    }
  }, [_vm._v(_vm._s(_vm.msglist[_vm.$route.params.language][9]))])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'register',
        params: {
          language: _vm.$route.params.language
        }
      }
    }
  }, [_c('button', {
    staticClass: "mb-2 btn btn-primary",
    staticStyle: {
      "min-width": "40px"
    }
  }, [_vm._v(_vm._s(_vm.msglist[_vm.$route.params.language][10]))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col mb-0",
    class: _vm.alertObject,
    staticStyle: {
      "font-size": "1.2rem",
      "font-weight": "bold"
    }
  }, [_vm._v(" " + _vm._s(_vm.message) + " ")])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8e7a1914"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/auth/Forget.vue
// module id = 319
// module chunks = 0